import React from 'react';
import { Box, CircularProgress } from '@mui/material';

const FullPageLoader = () => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        bgcolor: 'rgba(236, 235, 232, 0.9)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1301
      }}
    >
      <CircularProgress size={60} />
    </Box>
  );
};

export default FullPageLoader;
